import { Typography } from 'src/components/common';
import ProfilePicture from 'src/components/profile/profilePicture/ProfilePicture';

import './searchKeyMemberItem.scss';

export type TSearchKeyMemberItem = {
  profilePic: string;
  userId: string;
  name: string;
  role: string;
  isUserSelected: boolean;
  updateSelectedUsers: ({ userId }: { userId: string }) => void;
};

const SearchKeyMemberItem = ({
  userId,
  profilePic,
  name = '',
  role = '',
  isUserSelected,
  updateSelectedUsers
}: TSearchKeyMemberItem) => {
  return (
    <div className="search-key-member-item">
      <div className="search-key-member-item__user-info">
        <input
          type="checkbox"
          checked={isUserSelected}
          onChange={() => updateSelectedUsers({ userId })}
        />
        <ProfilePicture
          url={profilePic}
          fallback={name[0]}
          className="search-key-member-item__user-info__profile-pic"
        />
        <div className="search-key-member-item__user-info__user">
          <div className="search-key-member-item__user-info__user__row">
            <Typography
              as="span"
              variant="body-2"
              fontWeight="semiBold"
              className="search-key-member-item__user-info__user__row__name"
            >
              {name}
            </Typography>
            <hr></hr>
            <Typography
              as="span"
              variant="caption"
              fontWeight="regular"
              className="search-key-member-item__user-info__user__row__role"
            >
              {role}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchKeyMemberItem;
